const AlertIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 39.869 35">
			<g id="alert-triangle" transform="translate(-0.552 -0.9)">
				<path
					id="Pfad_100"
					d="M20.487.9a5.224,5.224,0,0,1,4.472,2.523h0L39.721,28.064A5.224,5.224,0,0,1,35.236,35.9H5.719a5.224,5.224,0,0,1-4.453-7.86h0L16.02,3.409A5.224,5.224,0,0,1,20.487.9Zm0,3.483A1.741,1.741,0,0,0,19,5.213h0L4.268,29.806a1.741,1.741,0,0,0,1.47,2.612H35.216a1.741,1.741,0,0,0,1.5-2.588h0L21.975,5.217A1.741,1.741,0,0,0,20.487,4.383Zm.017,21.07a1.741,1.741,0,0,1,.2,3.47l-.221.012a1.741,1.741,0,0,1-.2-3.47Zm-.017-13.931a1.741,1.741,0,0,1,1.729,1.537l.012.2v6.965a1.741,1.741,0,0,1-3.47.2l-.012-.2V13.263A1.741,1.741,0,0,1,20.487,11.522Z"
					transform="translate(0 0)"
					fill="red"
				/>
			</g>
		</svg>
	);
};

export default AlertIcon;
